import { EmailVerificationConfirm } from "@/new-pages/auth/email-verification-confirm";
import { ForgotPassword } from "@/new-pages/auth/forgot-password";
import { ResetPassword } from "@/new-pages/auth/reset-password";
// Import all components directly instead of using dynamic imports
import { SignIn } from "@/new-pages/auth/sign-in";
import type { RouteObject } from "react-router-dom";

import { IN_SMB } from "@/lib/platform";

export const route: RouteObject = {
	children: [
		{
			path: "sign-in",
			Component: SignIn,
		},
		// Businesses sign themselves up in the business app only.
		...(IN_SMB
			? [
					{
						path: "sign-up",
						lazy: async () => {
							const { SignUp } = await import("@/new-pages/auth/sign-up");
							return { Component: SignUp };
						},
					},
				]
			: []),
		{
			path: "forgot-password",
			Component: ForgotPassword,
		},
		{
			path: "reset-password",
			Component: ResetPassword,
		},
		{
			path: "confirm-email",
			Component: EmailVerificationConfirm,
		},
	],
};
